import { component } from 'picoapp'
import { zelektor, loopify, smoothScroll } from '@/lib/utility-functions.js'

export default component((node,ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { nav, navItem: navItems, list } = zelektor(node)
    const brands = window.theme.brands.filter(b => b.show_on_page === true).sort((a,b) => a.vendor_name > b.vendor_name ? 1 : -1)


    /*******************************************************************************************************************************************/
    /* Insert Brands
    /*******************************************************************************************************************************************/
    insertBrands()

    function insertBrands() {
        const gender = localStorage.getItem('spreeglee_gender') || 'unisex'

        loopify(brands).forEach(brand => {
            const linkUrl = brand[`link_url_${gender}`]

            if (!linkUrl) return

            const element = document.createElement('li')
            element.classList.add('brands__list__item', 'is-active', 'js-listItem')
            element.dataset.letter = brand.vendor_name.charAt(0).toLowerCase()
            element.innerHTML =     `
                                    <div class="image-wrapper">
                                        <img src="${brand.logo_dark}" alt="${brand.vendor_name}">
                                    </div>
                                    <a href="${linkUrl ? linkUrl : ''}" class="brands__list__item__link"></a>
                                    `
            list.appendChild(element)
        })
    }


    /*******************************************************************************************************************************************/
    /* Nav
    /*******************************************************************************************************************************************/
    initNavItems()

    function initNavItems() {
        const { listItem: listItems = [] } = zelektor(list)
        const activeLetters = [...new Set(loopify(listItems).map(item => item.dataset.letter))]

        activeLetters.forEach(letter => {
            const matchingNavItem = loopify(navItems).find(item => item.dataset.letter === letter)
            matchingNavItem.classList.add('is-enabled')
            matchingNavItem.addEventListener('click', clickNavItem)
        })

        // Init 'all' too :-)
        loopify(navItems)[0].addEventListener('click', clickNavItem)
    }

    function clickNavItem(e) {
        const thisItem = e.currentTarget
        const { letter } = thisItem.dataset
        const { listItem: listItems } = zelektor(list)
        let firstMatchingListItem = letter === 'all' ? loopify(listItems)[0] : undefined

        // Activate / deactivate nav items
        loopify(navItems).forEach(item => item.classList.remove('is-active'))
        thisItem.classList.add('is-active')

        // Activate / deactivate list items
        loopify(listItems).forEach(item => {
            if (item.dataset.letter === letter || letter === 'all') {
                item.classList.add('is-active')
                if (!firstMatchingListItem) firstMatchingListItem = item
            } else {
                item.classList.remove('is-active')
            }
        })

        // Scroll to first matching list item
        if (firstMatchingListItem) scrollToListItem(firstMatchingListItem)
    }

    function scrollToListItem(item) {
        const headerContent = document.querySelector('.js-headerContent')
        const headerLogoWrapper = document.querySelector('.js-headerLogoWrapper')

        let offset
        if (window.innerWidth > 1024) {
            offset = headerLogoWrapper.offsetHeight - 1
        } else {
            offset = headerContent.offsetHeight - 1 + nav.offsetHeight
        }

        smoothScroll(item, { offset: offset * -1 })
    }
})